module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-infiniti.56c83b34.png";